import React, { FunctionComponent } from 'react';
import { OfferData } from '@upstart/harmony/lib/legos/deskingTypes';
import { FinanceType } from '@upstart/harmony/lib/constants';
import { startCase } from 'lodash';
import './OfferHeader.scss';

interface OfferHeaderProps {
  offerData?: OfferData | null;
}

export const OfferHeader: FunctionComponent<OfferHeaderProps> = ({
  offerData,
}) => {
  let detail = '';
  if (offerData?.financeType === FinanceType.PURCHASE) {
    detail = `${offerData?.months} months`;
  } else if (offerData?.financeType === FinanceType.LEASE) {
    detail = `${offerData?.months} months, ${offerData?.mileage} miles`;
  }
  const title = detail
    ? `${startCase(offerData?.financeType)} - ${detail}`
    : startCase(offerData?.financeType);
  return <div className="history-offer-header-container">{title}</div>;
};
